module.exports = __webpack_public_path__ + "static/media/google-play-mobile.bc3d2b6c.svg";